/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19 22V14M12 10V2M5 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19 5V2M19 5C20.6569 5 22 6.34315 22 8C22 9.65685 20.6569 11 19 11C17.3431 11 16 9.65685 16 8C16 6.34315 17.3431 5 19 5ZM12 22V19M12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 17.6569 13.6569 19 12 19ZM5 5V2M5 5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8C2 6.34315 3.34315 5 5 5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M2 8C2 6.34315 3.34315 5 5 5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8Z"
					fill="currentColor"
				/>
				<path
					d="M16 8C16 6.34315 17.3431 5 19 5C20.6569 5 22 6.34315 22 8C22 9.65685 20.6569 11 19 11C17.3431 11 16 9.65685 16 8Z"
					fill="currentColor"
				/>
				<path
					d="M9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 17.6569 13.6569 19 12 19C10.3431 19 9 17.6569 9 16Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M19 5V2M19 5C20.6569 5 22 6.34315 22 8C22 9.65685 20.6569 11 19 11C17.3431 11 16 9.65685 16 8C16 6.34315 17.3431 5 19 5ZM12 22V19M12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 17.6569 13.6569 19 12 19ZM5 5V2M5 5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8C2 6.34315 3.34315 5 5 5ZM19 22V14M12 10V2M5 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.75 2C5.75 1.58579 5.41421 1.25 5 1.25C4.58579 1.25 4.25 1.58579 4.25 2V4.58054C2.67741 4.92388 1.5 6.32444 1.5 8C1.5 9.933 3.067 11.5 5 11.5C6.933 11.5 8.5 9.933 8.5 8C8.5 6.32444 7.32259 4.92388 5.75 4.58054L5.75 2ZM12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2L11.25 10C11.25 10.4142 11.5858 10.75 12 10.75C12.4142 10.75 12.75 10.4142 12.75 10L12.75 2ZM19.75 2C19.75 1.58579 19.4142 1.25 19 1.25C18.5858 1.25 18.25 1.58579 18.25 2V4.58054C16.6774 4.92388 15.5 6.32444 15.5 8C15.5 9.933 17.067 11.5 19 11.5C20.933 11.5 22.5 9.933 22.5 8C22.5 6.32444 21.3226 4.92388 19.75 4.58054V2ZM5.75 14C5.75 13.5858 5.41421 13.25 5 13.25C4.58579 13.25 4.25 13.5858 4.25 14L4.25 22C4.25 22.4142 4.58579 22.75 5 22.75C5.41421 22.75 5.75 22.4142 5.75 22L5.75 14ZM19.75 14C19.75 13.5858 19.4142 13.25 19 13.25C18.5858 13.25 18.25 13.5858 18.25 14V22C18.25 22.4142 18.5858 22.75 19 22.75C19.4142 22.75 19.75 22.4142 19.75 22V14ZM11.25 19.4195C9.67741 19.0761 8.5 17.6756 8.5 16C8.5 14.067 10.067 12.5 12 12.5C13.933 12.5 15.5 14.067 15.5 16C15.5 17.6756 14.3226 19.0761 12.75 19.4195V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V19.4195Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19 5V2M19 5C20.6569 5 22 6.34315 22 8C22 9.65685 20.6569 11 19 11M19 5C17.3431 5 16 6.34315 16 8C16 8.35064 16.0602 8.68722 16.1707 9M12 22V19M12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 17.6569 13.6569 19 12 19ZM5 2V5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8C2 7.64936 2.06015 7.31278 2.17071 7M19 22V14M12 10V2M5 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19 5V2M19 5C20.6569 5 22 6.34315 22 8C22 9.65685 20.6569 11 19 11C17.3431 11 16 9.65685 16 8C16 6.34315 17.3431 5 19 5ZM12 22V19M12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 17.6569 13.6569 19 12 19ZM5 5V2M5 5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8C2 6.34315 3.34315 5 5 5ZM19 22V14M12 10V2M5 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 1.25C5.41421 1.25 5.75 1.58579 5.75 2L5.75 5C5.75 5.41421 5.41421 5.75 5 5.75C4.58579 5.75 4.25 5.41421 4.25 5L4.25 2C4.25 1.58579 4.58579 1.25 5 1.25ZM12 1.25C12.4142 1.25 12.75 1.58579 12.75 2L12.75 10C12.75 10.4142 12.4142 10.75 12 10.75C11.5858 10.75 11.25 10.4142 11.25 10L11.25 2C11.25 1.58579 11.5858 1.25 12 1.25ZM19 1.25C19.4142 1.25 19.75 1.58579 19.75 2V5C19.75 5.41421 19.4142 5.75 19 5.75C18.5858 5.75 18.25 5.41421 18.25 5V2C18.25 1.58579 18.5858 1.25 19 1.25ZM5 13.25C5.41421 13.25 5.75 13.5858 5.75 14L5.75 22C5.75 22.4142 5.41421 22.75 5 22.75C4.58579 22.75 4.25 22.4142 4.25 22L4.25 14C4.25 13.5858 4.58579 13.25 5 13.25ZM19 13.25C19.4142 13.25 19.75 13.5858 19.75 14L19.75 22C19.75 22.4142 19.4142 22.75 19 22.75C18.5858 22.75 18.25 22.4142 18.25 22L18.25 14C18.25 13.5858 18.5858 13.25 19 13.25ZM12 18.25C12.4142 18.25 12.75 18.5858 12.75 19V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V19C11.25 18.5858 11.5858 18.25 12 18.25Z"
				fill="currentColor"
			/>
			<path
				d="M5 4.5C3.067 4.5 1.5 6.067 1.5 8C1.5 9.933 3.067 11.5 5 11.5C6.933 11.5 8.5 9.933 8.5 8C8.5 6.067 6.933 4.5 5 4.5Z"
				fill="currentColor"
			/>
			<path
				d="M19 4.5C17.067 4.5 15.5 6.067 15.5 8C15.5 9.933 17.067 11.5 19 11.5C20.933 11.5 22.5 9.933 22.5 8C22.5 6.067 20.933 4.5 19 4.5Z"
				fill="currentColor"
			/>
			<path
				d="M12 12.5C10.067 12.5 8.5 14.067 8.5 16C8.5 17.933 10.067 19.5 12 19.5C13.933 19.5 15.5 17.933 15.5 16C15.5 14.067 13.933 12.5 12 12.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
